import { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useTranslation } from "react-i18next";
import Header from "@/components/Header";
import HomePage from "@/pages/HomePage";
import HistoryPage from "@/pages/HistoryPage";
import AdminPage from "@/pages/AdminPage";
import { registerServiceWorker } from "@/pwa";
import { trackView } from "@/lib/analytics";

function UsageTracker() {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    trackView(location.pathname, i18n.resolvedLanguage);
  }, [location.pathname, i18n.resolvedLanguage]);
  return null;
}

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border/60 mt-10">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-6 flex items-center justify-between text-xs text-muted-foreground">
        <span data-testid="footer-copy">
          © {new Date().getFullYear()} iDiag — {t("footer.rights")}
        </span>
        <span className="font-mono opacity-60">v0.1.0</span>
      </div>
    </footer>
  );
}

function App() {
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <UsageTracker />
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/historial" element={<HistoryPage />} />
            <Route path="/historial/:id" element={<HistoryPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "hsl(230 25% 8%)",
            border: "1px solid hsl(230 20% 16%)",
            color: "hsl(220 15% 95%)",
          },
        }}
      />
    </div>
  );
}

export default App;
